import {Component, Input, OnInit} from '@angular/core';
import {SpinnerService} from "../../../modules/spinner/spinner.service";
import {SnackBarService} from "../../shared-components/snack-bar/snack-bar.service";
import {ConfigTurnsService} from "../../../services/turns-services/config-turns-service/config-turns.service";
import {ImageDialogComponent} from "../../shared-components/image-dialog/image-dialog.component";
import {MultimediaManagerComponent} from "../../../modules/multimedia-manager/multimedia-manager/multimedia-manager.component";
import {MatDialog} from "@angular/material/dialog";

@Component({
  selector: 'app-turns-config-ui-background-image-card',
  templateUrl: './turns-config-ui-background-image-card.component.html',
  styleUrls: ['./turns-config-ui-background-image-card.component.scss']
})
export class TurnsConfigUiBackgroundImageCardComponent implements OnInit {

  @Input() image;
  @Input() title: string;
  @Input() width: string;
  @Input() height: string;
  showSpinner: boolean;

  constructor(private spinnerService: SpinnerService,
              private dialog: MatDialog,
              private snackbarService: SnackBarService,
              private configTurnsService: ConfigTurnsService) { }

  ngOnInit() {
    this.showSpinner = false;
  }

  public updateTurnTicketImage(imageUrl) {
    this.showSpinner = true;
    this.spinnerService.show('turn-config-image-spinner');
    this.configTurnsService.updateTurnsUiBackgroundImage(imageUrl).subscribe(
      (res) => {
        this.showSpinner = false;
        this.spinnerService.hide('turn-config-image-spinner');
        this.configTurnsService.refreshTurnsConfig();
        this.snackbarService.open('validation-images.snackbar messages.update image success', 'success');
      },
      (error) => {
        this.showSpinner = false;
        this.spinnerService.hide('turn-config-image-spinner');
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public deleteAsset() {
    this.showSpinner = true;
    this.spinnerService.show('turn-config-image-spinner');
    this.configTurnsService.updateTurnsUiBackgroundImage(null).subscribe(
      (res) => {
        this.showSpinner = false;
        this.spinnerService.hide('turn-config-image-spinner');
        this.configTurnsService.refreshTurnsConfig();
        this.snackbarService.open('validation-images.snackbar messages.update image success', 'success');
      },
      (error) => {
        this.showSpinner = false;
        this.spinnerService.hide('turn-config-image-spinner');
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public zoom() {
    const dialogRef = this.dialog.open(ImageDialogComponent, { data: { image: this.image, info: { title: this.title, subtitle: this.width + 'x' + this.height }}});
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        if (res === 'upload') {
          this.uploadPhotoClicker();
        } else if (res === 'delete') {
          this.deleteAsset();
        }
      }
    });
  }

  public uploadPhotoClicker() {
    const dialogRef = this.dialog.open(MultimediaManagerComponent, { data: { multi: false } });
    dialogRef.beforeClosed().subscribe(
      (result) => {
        if (result) {
          this.updateTurnTicketImage(result[0].Url);
        }
      }
    );
  }
}
